import controller_0 from '@fify/form-bundle/controllers/number_input_controller.js';
import controller_1 from '@fify/form-bundle/controllers/tomselect_controller.js';
import controller_2 from '@fify/websites-bundle/controllers/cookie-consent_controller.js';
import controller_3 from '@symfony/ux-autocomplete/dist/controller.js';
import controller_4 from '@symfony/ux-live-component/dist/live_controller.js';
import '@symfony/ux-live-component/dist/live.min.css';
import controller_5 from '@symfony/ux-turbo/dist/turbo_controller.js';
import '@symfony/ux-turbo/dist/mercure_stream_source_element.js';
import { Controller } from '@hotwired/stimulus';
export default {
  'fify--form-bundle--number-input': controller_0,
  'fify--form-bundle--submit-confirm': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/form-bundle/controllers/submit-confirm_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--form-bundle--collection': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/form-bundle/controllers/collection_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--form-bundle--tomselect': controller_1,
  'fify--security-bundle--altcha': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/security-bundle/controllers/altcha_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--websites-bundle--cookie-consent': controller_2,
  'fify--websites-bundle--file-download': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/websites-bundle/controllers/file-download_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--websites-bundle--modal': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/websites-bundle/controllers/modal_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'symfony--ux-autocomplete--autocomplete': controller_3,
  'live': controller_4,
  'symfony--ux-turbo--turbo-core': controller_5,
};